define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var touchDetectedCallbacks = [];
    var touchEventDetected = false;
    function handleTouchCallbacks() {
        touchDetectedCallbacks.forEach(function (callback) {
            if (typeof callback === "function") {
                callback();
            }
        });
    }
    exports.handleTouchCallbacks = handleTouchCallbacks;
    function isTouchEvent(event) {
        if (event.type === "touchstart") {
            return true;
        }
        else if (event.originalEvent.pointerType) {
            switch (event.originalEvent.pointerType) {
                // Browser bis IE 10
                case 2:
                case 3:
                // Browser ab IE 11 + Edge
                case "touch":
                case "pen":
                    return true;
            }
        }
        return false;
    }
    function handleTouch(event) {
        if (!touchEventDetected && isTouchEvent(event)) {
            touchEventDetected = true;
            handleTouchCallbacks();
        }
    }
    function isTouchEventDetected() {
        return touchEventDetected;
    }
    exports.isTouchEventDetected = isTouchEventDetected;
    function registerTouchDetectedCallback(callback) {
        touchDetectedCallbacks.push(callback);
    }
    exports.registerTouchDetectedCallback = registerTouchDetectedCallback;
    $(function () {
        $("body").one("touchstart pointerdown MSPointerDown", handleTouch);
    });
});
